import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  autoBet, cancelBetMineService, cashOutBet, getBetHistory, getLiveStats, getPreviousRoundState, getTopBets, openTile, placeBet
} from '../services/gongaMine.service'
import { setMinesLossCount, setMinesProfit, setMinesWagered, setMinesWinsCount, setRoundResult } from '../slices-thunks/gongaMineGame.slice'
import { BET_RESULT } from 'constants/index'
import { openSuccessToaster } from 'helpers/toaster.helpers'
import i18n from 'i18next'


export const getMineGamePreviousRoundState = createAsyncThunk(
  'mineGame/get-previous-round-state', async (_, thunkApi) => {
    try {
      const res = await getPreviousRoundState()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const getMyBetsMineGame = createAsyncThunk(
  'mineGame/get-my-bets', async (data, thunkApi) => {
    try {
      const res = await getBetHistory(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGamePlacedBet = createAsyncThunk(
  'mineGame/place-bet', async ({ payload }, thunkApi) => {
    try {
      const res = await placeBet(payload)
      if (res) {
        thunkApi.dispatch(setMinesWagered(res?.betAmount))
      }
      openSuccessToaster({ message: i18n.t('BET_PLACED_SUCCESS') })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineCancelBetThunk = createAsyncThunk(
  'mineGame/cancel-bet', async (_, thunkApi) => {
    try {
      const res = await cancelBetMineService()
      openSuccessToaster({ message: i18n.t('CANCEL_PLACED_SUCCESSFULLY') })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGameAutoBet = createAsyncThunk(
  'mineGame/auto-bet', async ({ payload, normalTileAudio, mineTileAudio }, thunkApi) => {
    try {
      const res = await autoBet(payload)
      if (res) {
        thunkApi.dispatch(setMinesWagered(Number(res?.betAmount)))
      }
      setTimeout(() => {
        if (res?.result === BET_RESULT.LOST) {
          thunkApi.dispatch(setRoundResult({ isLastWin: false, isLastLoss: true }))
          thunkApi.dispatch(setMinesLossCount())
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesWagered(res?.betAmount))
        } else {
          thunkApi.dispatch(setMinesWinsCount())
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesWagered(res?.betAmount))
          thunkApi.dispatch(setRoundResult({ isLastWin: true, isLastLoss: false }))
        }
      }, 2000)
      if (thunkApi.getState().gameSetting.gameSound) {
        res?.result === BET_RESULT.WON ? normalTileAudio?.play() : mineTileAudio?.play()
      }
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGameOpenTile = createAsyncThunk(
  'mineGame/opened-tile', async (payload, thunkApi) => {
    try {
      const { normalTileAudio, mineTileAudio, tile } = payload
      const { minesVolume } = thunkApi?.getState()?.mineGame
      const res = await openTile({ tile })
      if (res?.result) {
        if (res?.result === 'won') {
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesWinsCount(res))
        } else if (res?.result === 'lost') {
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesLossCount(res))
        }
      }
      if (res?.mineTile) {
        setTimeout(() => {
          thunkApi.dispatch(setRoundResult({ isLastWin: false, isLastLoss: true }))
        }, 2000)
        if (thunkApi.getState().gameSetting.gameSound) {
          mineTileAudio.volume = minesVolume
          mineTileAudio?.play()
        }
      } else if (thunkApi.getState().gameSetting.gameSound) {
        normalTileAudio.volume = minesVolume
        normalTileAudio?.play()
      }
      res.tile = payload.tile
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGameCashOut = createAsyncThunk(
  'mineGame/cash-out', async ({ mineCashOutAudio }, thunkApi) => {
    try {
      const res = await cashOutBet()
      setTimeout(() => {
        thunkApi.dispatch(setRoundResult({ isLastWin: true, isLastLoss: false }))
      }, 2000)
      mineCashOutAudio?.play()
      if (res?.result) {
        if (res?.result === 'won') {
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesWinsCount(res))
        } else if (res?.result === 'lost') {
          thunkApi.dispatch(setMinesProfit(res))
          thunkApi.dispatch(setMinesLossCount(res))
        }
      }
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const minGameTopBets = createAsyncThunk(
  'mineGame/top-bets', async (_, thunkApi) => {
    try {
      const res = await getTopBets()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const verifyProvableFairMine = createAsyncThunk('crash-game/check-provable-fair', async (payload, thunkApi) => {
  try {
    const res = await verifyProvableFairMine(payload)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMineGameLiveStats = createAsyncThunk(
  'mineGame/get-mine-game-live-stats', async (_, thunkApi) => {
    try {
      const res = await getLiveStats()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)
